import axios from 'axios'

import router from './router'
axios.defaults.timeout = 3000000;
//axios.defaults.baseURL = 'https://localhost:44388/api/';
//axios.defaults.baseURL = 'https://ap2.bjcreate.net/api/';
//axios.defaults.baseURL = 'http://10.254.3.12:801/api/';
// axios.defaults.baseURL = 'https://localhost:44388/api/';
axios.defaults.baseURL = 'https://corpcswechat.nestlechinese.com/api/';
// axios.defaults.baseURL = 'https://corpcswechatstaging.nestlechinese.com/api/';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  if (config.url !== 'login') {
    // Authorization
    let loginModel = JSON.parse(localStorage.getItem("USER_INFO"))
    if (loginModel == null) {
      return config;
    }
    let lastvisit = localStorage.getItem('lastvisit')
    if (loginModel != undefined && loginModel.token != undefined && loginModel != null) {
      config.headers.Authorization = loginModel.token;
      if (lastvisit) {
        config.headers.LastVisit = lastvisit;
      }
    } else {
      router.push({
        path: '/login'
      })
      return config;
    }
  }
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {

  if (response.data.status != undefined && response.data.status == 301) { //token过期
    alert("Token已过期，请重新登录!");
    localStorage.clear();
    router.push({
      path: '/login'
    })
    return response
  }
  if (response.data.status != undefined && response.data.status == 401) {
    alert("Token已过期，请重新登录!");
    localStorage.clear();
    router.push({
      path: '/login'
    })
    return response
  }
  if (response.headers.lastvisit != undefined) {
    localStorage.setItem('lastvisit', response.headers.lastvisit);
  }
  if (response.headers.tokennew != undefined) {
    let loginModel = JSON.parse(localStorage.getItem("USER_INFO"))
    loginModel.token = response.headers.tokennew;
    localStorage.setItem("USER_INFO", JSON.stringify(loginModel))
  }
  return response;
}, function (error) {

  // 对响应错误做点什么
  if (error.response != undefined) {
    if (error.response.status == 401) {
      alert("Token已过期，请重新登录!");
      localStorage.clear();
      router.push({
        path: '/login'
      })
    }

    router.push({
      path: getErrorAddress(error.response.status)
    })


    return Promise.reject(error);
  } else {
    router.push({
      path: getErrorAddress(500)
    })
  }
  return Promise.reject(error);
});

function getErrorAddress(status) {
  let href = location.href;
  let val = 0 // 0管理端  1 坐席端
  if (href.indexOf('manage') > -1) {
    val = 0;
  } else {
    val = 1;
  }
  let address = "";
  switch (status) {
    case 403:
      if (val == 0) {
        address = "/manage/err403"
      } else {
        address = "/customs/err403";
      }
      break;
    case 404:
      if (val == 0) {
        address = "/manage/err404"
      } else {
        address = "/customs/err404";
      }
      break;
    case 500:
      if (val == 0) {
        address = "/manage/err500"
      } else {
        address = "/customs/err500";
      }
      break;

  }
  return address;
}

export default axios



// WEBPACK FOOTER //
// ./src/http.js